import Vue from 'vue'
import App from './App.vue'
import router from './router'; // 导入路由配置
import store from './store'; // 导入 Store 配置
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
new Vue({
	router, // 注入路由
	store,
	ElementUI,
	render: h => h(App),
}).$mount('#app')